import React, { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

interface MediaLightboxProps {
  children: React.ReactNode;
  content: React.ReactNode;
}

export default function MediaLightbox({
  children,
  content,
}: MediaLightboxProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div onClick={() => setIsOpen(true)} className="cursor-zoom-in">
        {children}
      </div>
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent
          className="max-w-3xl border-none p-0 bg-background md:rounded-xl shadow-xl max-h-full md:max-h-[90vh] overflow-y-auto"
        >
          <div className="relative w-full h-full">
            <div id="di-img-wrapper" className="w-full h-full">
              {content}
            </div>
          
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
